'use strict';

var cov_ts8t4x659 = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/streamOnline/lib/reducer.js',
      hash = '05f25ca55331c6a6604d54020e93af1861492d46',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/streamOnline/lib/reducer.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 40
        },
        end: {
          line: 10,
          column: 1
        }
      },
      '1': {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 56,
          column: 1
        }
      },
      '2': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      '3': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 20,
          column: 8
        }
      },
      '4': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 62
        }
      },
      '5': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 28,
          column: 8
        }
      },
      '6': {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 36,
          column: 8
        }
      },
      '7': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 45
        }
      },
      '8': {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      '9': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 44,
          column: 10
        }
      },
      '10': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 52,
          column: 8
        }
      },
      '11': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 19
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 12,
            column: 21
          },
          end: {
            line: 12,
            column: 22
          }
        },
        loc: {
          start: {
            line: 12,
            column: 93
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 12
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 12,
            column: 80
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 80
          }
        }],
        line: 12
      },
      '1': {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 20,
            column: 8
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 28,
            column: 8
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 36,
            column: 8
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 38,
            column: 45
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 52,
            column: 8
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 54,
            column: 19
          }
        }],
        line: 14
      },
      '2': {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 40
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0],
      '1': [0, 0, 0, 0, 0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StreamOnlineReducerInitialState = (cov_ts8t4x659.s[0]++, {
  LOADING: false,
  ERROR: false,
  isShowDialog: false,
  dialogActionUrl: null,
  streamContentValue: null
});

cov_ts8t4x659.s[1]++;
var streamOnline = function streamOnline() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_ts8t4x659.b[0][0]++, (0, _assign2.default)({}, StreamOnlineReducerInitialState));
  var action = arguments[1];
  cov_ts8t4x659.f[0]++;

  var streamContentValue = void 0;
  cov_ts8t4x659.s[2]++;
  switch (action.type) {
    case _constants2.default.STREAM_ONLINE_BEFORE_LOAD:
      cov_ts8t4x659.b[1][0]++;
      cov_ts8t4x659.s[3]++;

      return (0, _extends3.default)({}, state, {
        LOADING: true,
        ERROR: false
      });
    case _constants2.default.STREAM_ONLINE_LOAD_SUCCESS:
      cov_ts8t4x659.b[1][1]++;
      cov_ts8t4x659.s[4]++;

      streamContentValue = _model2.default.get(action.data);
      cov_ts8t4x659.s[5]++;
      return (0, _extends3.default)({}, streamContentValue, {
        dialogActionUrl: null,
        LOADING: false,
        ERROR: false
      });
    case _constants2.default.STREAM_ONLINE_LOAD_ERROR:
      cov_ts8t4x659.b[1][2]++;
      cov_ts8t4x659.s[6]++;

      return (0, _extends3.default)({}, state, {
        isShowDialog: true,
        dialogActionUrl: action.dialogAction,
        LOADING: false,
        ERROR: true
      });
    case _constants2.default.STREAM_ONLINE_INITIAL_STATE:
      cov_ts8t4x659.b[1][3]++;
      cov_ts8t4x659.s[7]++;

      return StreamOnlineReducerInitialState;
    case _constants2.default.STREAM_ONLINE_UPDATE_DIALOG_VISIBILITY:
      cov_ts8t4x659.b[1][4]++;
      cov_ts8t4x659.s[8]++;

      if (action.isVisible) {
        cov_ts8t4x659.b[2][0]++;
        cov_ts8t4x659.s[9]++;

        return (0, _extends3.default)({}, state, {
          isShowDialog: true
        });
      } else {
        cov_ts8t4x659.b[2][1]++;
      }
      cov_ts8t4x659.s[10]++;
      return (0, _extends3.default)({}, state, {
        ERROR: false,
        isShowDialog: false,
        dialogActionUrl: null,
        streamContentValue: null
      });
    default:
      cov_ts8t4x659.b[1][5]++;
      cov_ts8t4x659.s[11]++;

      return state;
  }
};
exports.default = streamOnline;